import { styled } from '@mui/material/styles'
import OcrReaderLogo from 'assets/images/logoStk.svg'

const H1 = styled('h1')({
  textAlign: 'center',
  alignItems: 'center',
  margin: 0,
  fontSize: 0,
})

export default function Logo() {
  return (
    <H1>
      LINE WORKS OCR
      <img width="75%" src={OcrReaderLogo} alt="logo" />
    </H1>
  )
}
